import { atom } from "@mongez/react-atom";
import { Product } from "../../catalog";
import type { Wishlist } from "../types";

export const wishlistAtom: any = atom<Wishlist>({
  key: "wishlist",
  default: {
    products: [],
    totalWishlist: 0,
  },
  actions: {
    removeProduct: (product: Product) => {
      const products = wishlistAtom.get("products");
      const newProducts = products.filter((item) => item.id !== product.id);

      wishlistAtom.update({
        products: newProducts,
        totalWishlist: newProducts.length,
      });
    },
    addProduct: (product: Product) => {
      const products = wishlistAtom.get("products");
      const newProducts = [...products, product];

      wishlistAtom.update({
        products: newProducts,
        totalWishlist: newProducts.length,
      });
    },
  },
  beforeUpdate: (wishlist: Wishlist) => {
    if (wishlist.products) {
      wishlist.totalWishlist = wishlist.products.length;
    }
    return wishlist;
  },
});
